//
// Navigation
//

const $ = window.jQuery;

//
// Add class to submenus with more than one submenu link
//
$( '.iec-desktop-menu nav > ul > li' ).each( function() {

	if ( 1 < $( this ).children( 'ul' ).children( 'li.fl-has-submenu' ).length ) {
		$( this ).children( 'ul' ).addClass( 'horizontal' );
	}

} );
